import { AxiosRequestConfig } from 'axios';
import { initData } from './helpers';

class PiBaseUrlInterceptor {
  public intercept(config: AxiosRequestConfig): Promise<AxiosRequestConfig> {
    const url = initData().app?.piApiUrl;

    if (url) {
      config.baseURL = url;
    }

    return Promise.resolve(config);
  }
}

export default PiBaseUrlInterceptor;
